<div class="pb-20 pt-2">
  <h2 class="text-center font-medium text-4xl mb-10">
    {{ 'footer.search.title' | transloco }}
  </h2>
  <homey-housing-opportunities-search
    ngSkipHydration
    [route]="['apartments'] | translateRoute: translateService.language()"
    [excludeLotteryId]="excludeLotteryId()"
    [replace]="false"
    [dividerBackground]="'white'"
  />
</div>

<homey-full-footer [defaultSignupRoute]="defaultSignupRoute()">
  <ng-content select="[footerTitle]">
    {{ 'footer.hero.line1' | transloco }}<br />
    <span class="text-orange-gradient">
      {{ 'footer.hero.line2' | transloco }}
    </span>
  </ng-content>
</homey-full-footer>
